const StatusProgramacaoCarga = {
    PREVISTO: 1,
    CONFIRMADO: 2
}

export default StatusProgramacaoCarga;